<template>
  <div class="w-full border-y border-neutral-300 max-w-[1344px] ">
    <div class="py-10 max-w-[1112px] mx-auto">
      <div class="w-full h-4/5">
        <header class="flex items-center mb-6">
          <div v-if="!topic?.userAuthor?.photoProfile">
            <img class="object-cover w-12 h-12 mr-6 rounded-full cursor-pointer" src="@/assets/images/user-topic.svg"
              alt="user" />
          </div>
          <div v-else-if="topic.userAuthor.photoProfile">
            <img class="object-cover w-12 h-12 mr-6 rounded-full cursor-pointer"
              :src="topic.userAuthor?.photoProfile.path" alt="user" />
          </div>
          <div>
            <h6 class="text-base font-bold text-h-neutral-700">
              {{ topic?.userAuthor?.name }}
            </h6>
            <p class="text-sm text-h-neutral-700">
              {{ $t("labels.generic", { pt: "Publicado", en: "Published" }) }}
              {{ timeSinceCreation }}
            </p>
          </div>
        </header>
        <div>
          <p
            class="py-1 pl-2 pr-1 mb-3 text-base font-bold border-l-2 text-h-primary-500 border-h-primary-500 bg-neutral-100 w-fit"
          >
            {{ topic?.tag || "Placeholder" }}
          </p>
        </div>
        <h4 class="text-2xl font-medium leading-8 break-all">
          {{ topic?.title }}
        </h4>
        <div class="custom-quill">
          <p v-html="topic?.description" class="ql-editor !p-0 mt-4 text-[14px]"></p>
          <div v-if="topic?.media" class="!w-full flex justify-center bg-black mt-6">
            <Image :src="topic.media.path" alt="topic image" preview
              imageClass="!w-full !object-cover !h-[600px] !min-h-[150px] !max-h-[450px] " />
          </div>
        </div>

        <footer class="flex justify-between mt-6 md:gap-3">
          <div class="grid grid-cols-2">
            <span class="flex justify-center items-center gap-2 text-h-primary-500">
              <v-icon name="md-chatbubbleoutline-round" scale="0.72" />
              <p class="text-base font-bold text-h-primary-500" v-if="topic?.commentAmount === 1">
                {{ topic.commentAmount }}
                {{ $t("labels.generic", { pt: "comentário", en: "comment" }) }}
              </p>
              <p v-else class="text-base font-bold text-h-primary-500">
                {{ topic?.commentAmount }}
                {{ $t("labels.generic", { pt: "comentários", en: "comments" }) }}
              </p>
            </span>

            <span class="flex justify-center items-center gap-2 font-bold cursor-pointer" :class="topic?.userLiked ? 'text-h-secondary-600' : 'text-h-primary-500'
              " @click="likeTopic">
              <v-icon name="ri-thumb-up-line" scale="0.875" />
              <p v-if="topic?.likeAmount === 1">
                {{ topic?.likeAmount }}
                {{ $t("labels.generic", { pt: "curtida", en: "like" }) }}
              </p>
              <p v-else>
                {{ topic?.likeAmount }}
                {{ $t("labels.generic", { pt: "curtidas", en: "likes" }) }}
              </p>
            </span>
          </div>
          <div class="flex">
            <div class="custom-dropdownforum flex flex-row justify-between items-center">
              <div class="lg:hidden" v-if="topicItems().length > 1">
                <Dropdown dropdownIcon="pi pi-ellipsis-v" :options="topicItems()" class="mt-3">
                  <template #option="SlotProps">
                    <button class="flex gap-2 items-center w-[212px] btn-simple"
                      @click="methodHandler(SlotProps.option.method)">
                      <v-icon :name="SlotProps.option.icon"></v-icon>
                      <p class="text-base font-bold">
                        {{ $t("labels.generic", {
                        pt: SlotProps.option.labelPT,
                        en: SlotProps.option.labelEN
                        }) }}
                      </p>
                    </button>
                  </template>
                </Dropdown>
              </div>
              <div class="lg:hidden" v-else v-for="option in topicItems()">
                <button class="flex gap-2 items-center justify-center cursor-pointer pr-4 btn-simple" @click="methodHandler(option.method)" >
                  <v-icon :name="option.icon" scale="0.8"></v-icon>
                </button>
              </div>

              <div class="hidden lg:flex lg:gap-6">
                <span v-for="option in topicItems()" class="flex items-center cursor-pointer">
                  <Button class="text-base font-bold btn-simple !p-0" @click="methodHandler(option.method)">
                    <v-icon :name="option.icon" scale="0.8" class="mr-2"></v-icon>
                    {{ $t('labels.generic', { pt: option.labelPT, en: option.labelEN }) }}
                  </Button>
                </span>
                <ConfirmDialog group="templating" :style="{ maxWidth: '490px' }" class="custom-confirm-dialog w-11/12">
                </ConfirmDialog>
                <Dialog modal group="closeTopic" v-model:visible="closeTopicDialogVisible" :style="{ maxWidth: '540px'}"
                  class="w-11/12 custom-dialogForum text-h-neutral-900">
                  <template #header>
                    <div class="flex justify-center w-full">
                      <h5 class="text-xl font-medium text-h-neutral-900">
                        Fechar tópico?
                      </h5>
                    </div>
                  </template>
                  <div class="m-4 mt-8">
                    <p class="text-base font-semibold leading-5 font text-neutral-900">{{ $t("labels.generic", {
                      pt: "Selecione como você gostaria de classificar o tópico. Ao confirmar, o tópico será fechado para novos comentários",
                      en: "Select how you would like to classify the topic.Upon confirmation, the topic will be closed to new comments"}) }}</p>
                  </div>
                  <div class="flex flex-col p-4 pt-0">
                    <div class="mb-4 flex items-center">
                      <RadioButton v-model="selectedTopicStatus" inputId="solved" name="solved" value="SOLVED" />
                      <label for="solved" class="ml-2">
                        <p>
                          <span class="font-bold">
                            {{ $t("labels.generic", {pt: "Marcar como resolvido - ", en: "Mark as resolved - "}) }}
                          </span>
                          <span>
                            {{ $t("labels.generic", { pt: "Indicado para tópicos que tiveram a dúvida respondida no comentário.",
                            en: "Recommended for topics that had the question answered in the comment." }) }}
                          </span>
                        </p>
                      </label>
                    </div>
                    <div class="mb-4 flex">
                      <RadioButton v-model="selectedTopicStatus" inputId="closed" name="closed" value="CLOSED" />
                      <label for="closed" class="ml-2">
                        <p>
                          <span class="font-bold">
                            {{ $t("labels.generic", {pt: "Encerrar tópico - ", en: "Close topic - "}) }}
                          </span>
                          <span>
                            {{ $t("labels.generic", { pt: "Indicado para tópicos inativos por muito tempo",
                            en: "Suitable for topics that have been inactive for a long time" }) }}
                          </span>
                        </p>
                      </label>
                    </div>
                  </div>
                    <template #footer>
                      <Button label="Cancelar" text severity="secondary" autofocus
                        @click="isCloseTopicDialogVisible(false)" class="h-8 btn-outline" />
                      <Button label="Fechar tópico" outlined severity="secondary" autofocus @click="markTopicAsResolved()"
                        class="h-8 py-4 btn-primary" :disabled="isCloseTopicButtonDisabled()"/>
                    </template>
                </Dialog>
              </div>
            </div>
          </div>
        </footer>
        <div>
          <a href="#box-comment" v-if="topicStatus() === 'ACTIVE'">
            <button class="btn-primary text-base w-[181px] h-8 rounded mt-6">
              {{ $t("labels.generic", { pt: "Adicionar comentário", en: "Add comment" }) }}
            </button>
          </a>
          <span v-else-if="topicStatus() === 'SOLVED'" class="flex flex-row p-1 bg-h-success-50 gap-1 w-fit mt-[26px]">
            <v-icon name="fc-checkmark" />
            <p class="text-h-success-500">
              {{ $t("labels.generic", { pt: "TÓPICO RESOLVIDO", en: "SOLVED TOPIC" }) }}
            </p>
          </span>
          <span v-else class="flex flex-row p-1 bg-h-neutral-300 gap-1 w-fit mt-[26px]">
            <v-icon name="io-checkmark" />
            <p class="text-h-neutral-800">
              {{ $t("labels.generic", { pt: "TÓPICO ENCERRADO", en: "CLOSED TOPIC" }) }}
            </p>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { StatusTopic } from "@/models/topic.model";
import { defineComponent } from "vue";
import moment from "moment";
import { ForumService } from "../../forum.service";
import { take } from "rxjs";
import { getUserFromStorage } from "@/utils/user-store.util";
import { GenericsUtils } from "@/utils/generics.util";
import { ToastFactory } from "@/utils/toast-factory.util";
import { Messages } from "@/utils/messages.util";
import { GoToRoute } from "@/utils/go-to.util";
import TopicCardDetail from "./topic-card.service";
import { Roles } from "@/models/user.model";
import { topicOptions } from "./items-topic-card.utils";

export default defineComponent({
  name: "topic-card-detailed",
  data() {
    return {
      disableButtonLike: false,
      params: {
        topicId: this.$route.params.topicId as string,
        courseName: this.$route.params.courseName as string,
        id: this.$route.params.id as string,
      },
      closeTopicDialogVisible: false,
      selectedTopicStatus: "",
    };
  },
  props: {
    topic: Object,
  },
  methods: {
    likeTopic(): void {
      this.disableButtonLike = true;
      this.service.topic.pipe(take(1)).subscribe({
        next: () => {
          this.setLikeAmountTopic();
        },
      });
      this.service.likeTopic(this.params.topicId);
    },

    reportTopic(): void {
      this.$emit("denounceTopic");
    },

    markTopicAsResolved(): void {
      const status = this.selectedTopicStatus;
      const topicContent = { ...this.topic, mediaId:this.topic?.media?.id, status: status, courseId: this.params.id };
      const appendName: any = { file: "file", data: "topic" };
      const topicFormat = this.generics.fileBuild(topicContent, "", appendName);
      this.service.topic.pipe(take(1)).subscribe({
        next: (response) => {
          if(response) {
            switch (response.status){
              case  StatusTopic.SOLVED:
              this.$toast.add(
                ToastFactory.success(Messages.TOPIC_MARKED_AS_RESOLVED)
              );
              break;
              case StatusTopic.ACTIVE:
              this.$toast.add(
                ToastFactory.success(Messages.TOPIC_MARKED_AS_OPEN)
              );
              break;
              case StatusTopic.CLOSED:
              this.$toast.add(
                ToastFactory.success(Messages.TOPIC_MARKED_AS_CLOSED)
              );
              break;
            }
            if (this.topic) this.topic.status = status;            
          }
        }
      });
      this.service.updateTopic(this.topic?.id, topicFormat);
      this.isCloseTopicDialogVisible(false);
    },

    deleteTopic(): void {
      this.service.topic.pipe(take(1)).subscribe({
        next: (response) => {
          if(response !== null) {
            this.$toast.add(ToastFactory.success(Messages.TOPIC_DELETED));
            this.redirectToForum();
          }
        },
      });
      this.service.deleteTopic(this.topic?.id);
    },

    setLikeAmountTopic(): void {
      if (this.topic) {
        if (this.topic?.userLiked) {
          this.topic.likeAmount -= 1;
        } else {
          this.topic.likeAmount += 1;
        }
        this.topic.userLiked = !this.topic.userLiked;
      }
      this.disableButtonLike = false;
    },

    redirectToEditTopic(): void {
      this.go.redirectToPage("editTopic", this.params);
    },

    redirectToForum(): void {
      this.go.redirectToPage("forum");
    },

    getUserRoleLogged(): Roles {
      return getUserFromStorage()?.role;
    },

    isAuthorOfTopic(): boolean {
      return getUserFromStorage().id === this.topic?.userAuthor?.id;
    },

    topicStatus(): StatusTopic {
      return this.topic?.status;
    },

    topicItems(): Array<topicOptions> {
      return this.topicCardDetailService.displayTopicOptions(
        this.getUserRoleLogged(), this.isAuthorOfTopic(), this.topicStatus()
      );
    },

    showDialogDeleteTopic(): void {
      this.$confirm.require({
        group: "templating",
        header: this.$t("labels.generic", {
          pt: "Excluir tópico?",
          en: "Delete topic?",
        }),
        message: this.$t("labels.generic", {
          pt: "Ao excluir, todos os comentários publicados no tópico serão descartados e não poderão ser visualizados. Após a confirmação, a ação não poderá ser desfeita.",
          en: "When you delete, all comments posted in the thread will be discarded and will not be viewable. Once confirmed, the action cannot be undone.",
        }),
        rejectLabel: this.$t("labels.generic", {
          pt: "Cancelar",
          en: "Cancel",
        }),
        acceptLabel: this.$t("labels.generic", {
          pt: "Excluir tópico",
          en: "Delete topic",
        }),
        acceptClass: "btn-delete-block",
        rejectClass: "btn-outline",
        accept: () => this.deleteTopic(),
      })
    },

    showDialogOpenTopic(): void {
      this.$confirm.require({
        group: "templating",
        header: this.$t("labels.generic", {
          pt: "Reabrir tópico?",
          en: "Reopen topic?",
        }),
        message: this.$t("labels.generic", {
          pt: "Ao confirmar, o tópico será reaberto para novos comentários.",
          en: "After confirmation, the topic will be reopened for new comments.",
        }),
        rejectLabel: this.$t("labels.generic", {
          pt: "Cancelar",
          en: "Cancel",
        }),
        acceptLabel: this.$t("labels.generic", {
          pt: "Reabrir tópico",
          en: "Reopen topic",
        }),
        acceptClass: "btn-primary",
        rejectClass: "btn-outline",
        accept: () => {
          this.selectedTopicStatus = "ACTIVE"
          this.markTopicAsResolved()
        },
      })
    },

    showDialogCloseTopic(): void {
      this. selectedTopicStatus = "";
      this.closeTopicDialogVisible = true;
    },

    methodHandler(method: string): void {
      switch (method) {
        case "delete":
          this.showDialogDeleteTopic()
          break;
        case "edit":
          this.redirectToEditTopic()
          break;
        case "closeTopic":
          this.showDialogCloseTopic()
          break;
        case "report":
          this.reportTopic()
          break;
        case "openTopic":
          this.showDialogOpenTopic()
          break;
      }
    },

    isCloseTopicDialogVisible(state: boolean): void {
      this.selectedTopicStatus = "";
      this.closeTopicDialogVisible = state;
    },

    isCloseTopicButtonDisabled(): boolean {
      return this.selectedTopicStatus === "";
    }
  },

  computed: {
    timeSinceCreation(): string {
      // moment.locale(navigator.language);
      moment.locale("pt-br");
      return moment(this.topic?.createdAt).add(3, "hour").fromNow();
    },

    service(): ForumService {
      return new ForumService();  
    },

    topicCardDetailService(): TopicCardDetail {
      return new TopicCardDetail()
    },

    generics(): GenericsUtils {
      return new GenericsUtils();
    },

    go(): GoToRoute {
      return new GoToRoute();
    }
  },
});
</script>
